import classNames from "classnames";
import React from "react";
import PropTypes from "prop-types";
import { QUIZ_ANSWER_STATES } from "../constants";
import QuizAnswerChoiceIcon from "./QuizAnswerChoiceIcon";
import ReviewButton from "./ReviewButton";

function QuizAnswerChoice({
  answerLetter,
  answerText,
  isSelectedAnswer,
  state,
  setSelectedAnswer,
  isAnonUser,
  link
}) {
  const isSelected = isSelectedAnswer && state === QUIZ_ANSWER_STATES.UNLOCKED;

  const handleAnswerSelected = (event) => {
    if (
      (!isAnonUser && !event.key) ||
      event.key === "Enter" ||
      event.key === " "
    ) {
      setSelectedAnswer(answerLetter);
    }
  };

  const canBeTabbed =
    (state === QUIZ_ANSWER_STATES.UNLOCKED ||
      state === QUIZ_ANSWER_STATES.LOCKED) &&
    !isSelectedAnswer;

  const amplitudeEvent =
    state === QUIZ_ANSWER_STATES.LOCKED
      ? "quizLockedAnswerChoice"
      : "quizUnlockedAnswerChoice";

  const amplitudeFunnel = () => {
    if (state === QUIZ_ANSWER_STATES.UNLOCKED) {
      return "none";
    }
    if (isAnonUser) {
      return "free";
    }
    return "paid";
  };

  return (
    <div
      className={classNames("quiz-answer-choice", state, {
        selected: isSelected
      })}
      data-amplitude={amplitudeEvent}
      data-amplitude-funnel={amplitudeFunnel()}
      data-testid={`QuizCardAnswerChoice-${answerLetter}`}
      onClick={handleAnswerSelected}
      onKeyPress={handleAnswerSelected}
      role="button"
      tabIndex={canBeTabbed ? 0 : undefined}
      {...(isAnonUser
        ? { "data-target": "#quiz-free-tier .modal", "data-toggle": "modal" }
        : {})}
    >
      <QuizAnswerChoiceIcon answerLetter={answerLetter} state={state} />
      <div className="text-content-container">
        <span
          className="response-text"
          dangerouslySetInnerHTML={{ __html: answerText }}
        />
        <ReviewButton link={link} state={state} />
      </div>
    </div>
  );
}

const propTypes = {
  answerLetter: PropTypes.string.isRequired,
  answerText: PropTypes.string.isRequired,
  isAnonUser: PropTypes.bool.isRequired,
  isSelectedAnswer: PropTypes.bool,
  link: PropTypes.string,
  setSelectedAnswer: PropTypes.func,
  state: PropTypes.oneOf(Object.values(QUIZ_ANSWER_STATES)).isRequired
};

const defaultProps = {
  isSelectedAnswer: false,
  link: undefined,
  setSelectedAnswer: () => {}
};

QuizAnswerChoice.propTypes = propTypes;
QuizAnswerChoice.defaultProps = defaultProps;

export default QuizAnswerChoice;
